import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { ICommitmentException } from '../classes/ICommitmentException';
import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const getExceptionsAsync = async (orderId: string, policyType: PolicyTypeEnum): Promise<any> => {
  try {
    const response = await APIFactory(baseUrlService.ApiLocation).get(
      `/policy_exceptions/v1/${orderId}/${getPolicyType(policyType)}`
    );
    return response.data;
  } catch (e: any) {
    axiosErrorHandler(e);
  }
};

export const initExceptionsAsync = async (orderId: string, policyType: PolicyTypeEnum): Promise<any> => {
  try {
    return await APIFactory(baseUrlService.ApiLocation).put(
      `/policy_exceptions/v1/${orderId}/${getPolicyType(policyType)}`
    );
  } catch (e: any) {
    axiosErrorHandler(e);
  }
};

export const resetExceptionsAsync = async (orderId: string, policyType: PolicyTypeEnum): Promise<any> => {
  try {
    return await APIFactory(baseUrlService.ApiLocation).put(
      `/policy_exceptions/v1/reset/${orderId}/${getPolicyType(policyType)}`
    );
  } catch (e: any) {
    axiosErrorHandler(e);
  }
};

export const saveExceptionsAsync = async (
  orderId: string,
  policyType: PolicyTypeEnum,
  newExceptions: ICommitmentException[]
): Promise<any> => {
  try {
    return await APIFactory(baseUrlService.ApiLocation).post(
      `/policy_exceptions/v1/${orderId}/${getPolicyType(policyType)}`,
      newExceptions
    );
  } catch (e: any) {
    axiosErrorHandler(e);
  }
};

export const deleteExceptionAsync = async (
  exceptionId: string,
  orderId: string,
  policyType: PolicyTypeEnum
): Promise<any> => {
  try {
    return await APIFactory(baseUrlService.ApiLocation).delete(
      `/policy_exceptions/v1/${orderId}/${exceptionId}/${getPolicyType(policyType)}`
    );
  } catch (e: any) {
    axiosErrorHandler(e);
  }
};

const getPolicyType = (policyType: PolicyTypeEnum | null): string => {
  let type: string;
  switch (policyType) {
    case PolicyTypeEnum.shortForm:
      type = 'loan';
      break;
    case PolicyTypeEnum.longForm:
      type = 'loan';
      break;
    default:
      type = 'owner';
      break;
  }
  return type;
};
